const EventBus = window.EventBus;
export const SpaInventory = {
  props: ['ipp', 'currentPageProp', 'urlParams', 'gutembergOptions', 'contentdir', 'loadMore', 'loadMoreBtn','imagesForModels', 'slick', 'paymentFrequency'],
  data() {
    return {
      initialInventory: [],
      stockNumber: null,
      priceRange: [],
      mileageRange: [],
      dryweightRange: [],
      grossweightRange: [],
      sleepcapacityRange: [],
      carprooflinkRange: [],
      filterValue: "",
      selected: {},
      inventory: [],
      currentPage: this.currentPageProp,
      loading: false,
      lMore: this.loadMore,
      lMoreBtn: this.loadMoreBtn,
      modelSelected: null,
      i: 1,
      displayMoreBtn: true,
    }
  },
created() {
      this.httpRequestInventory();
},
mounted() {
    EventBus.$on('goToCompare', this.goToCompare);
    EventBus.$on('filterInventory', this.filterInventory);
    EventBus.$on('goToPage', this.goToPage);
    EventBus.$on('sortInventory', this.sortInventory);
    this.scroll();

    // Activate Slick if its the case
    if(this.slick){
      setTimeout(() => {
       jQuery("[class*='lbx-inventory-container'].lbx-slick-act")
         .not(".slick-initialized")
         .slick({
           dots: false,
           infinite: true,
           speed: 500,
           slidesToShow: 4,
           slidesToScroll: 1,
           responsive: [
             { breakpoint: 1650, settings: { slidesToShow: 3, dots: false } },
             { breakpoint: 1280, settings: { slidesToShow: 2, dots: false } },
             { breakpoint: 1024, settings: { slidesToShow: 1, dots: false } },
           ],
         });
      }, 500);
    }
  },
  methods: {
    scroll() {
      if (this.lMore) {
        var val = true;
        window.onscroll = () => {

          // Crea un nuevo observador
          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.intersectionRatio > 0 && val) {
                  this.i = this.i + 1;
                  this.goToPage(this.i);
                  val = false;
                }
            });
          });

          // Inicia el observador
          setTimeout(() => {
            val = true;
          }, 1000);
        
          // Observa un elemento específico
          const selectores = ['.footer', '#lbx-scroll-div'];

          selectores.forEach(selector => {
            let elementos = document.querySelectorAll(selector);
            elementos.forEach(elemento => {
              observer.observe(elemento);
            });
          });
        };
      }
    },
    showMore() {
      if (this.lMoreBtn) {
        this.i = this.i + 1;
        this.goToPage(this.i);
      }
    },

    httpRequestInventory() {
      this.loading = true;
      EventBus.httpRequestInventory(this.contentdir, this.entryPoint, this.gutembergOptions);
    },
    entryPoint(inventory) {
      this.initialInventory = inventory;
      if (this.urlParams.sort_by_condition) {
        this.sortInventory({ field: this.urlParams.sort_by, order: this.urlParams.sort_by_condition });
      }else if(this.urlParams.sort_by === "make (custom)"){
        this.sortInventory({ field: "make (custom)", order: this.urlParams.order });
      }else if(this.urlParams.sort_by === "model (custom)"){
        this.sortInventory({ field: "model (custom)", order: this.urlParams.order});
      }else if(this.urlParams.sort_by === "location(custom)"){
        this.sortInventory({ field: "location (custom)", order: this.urlParams.order});
      }else if(this.gutembergOptions.sort_by === "price" && this.gutembergOptions.sort_by_condition === 'asc'){
        this.sortInventory({ field: "price", order: 'asc'});
      }
      this.filterInventory(this.computedParams);
      this.loading = false;
    },
    sortInventory(payload) {
      if(payload.field === 'make (custom)') {
        let uniqueMakes = this.initialInventory.map(item => item.make).filter((value, index, self) => self.indexOf(value) === index);
        let makesOrder = this.gutembergOptions.sort_makes;
        
        makesOrder = this.arrayUnique(makesOrder.concat(uniqueMakes)); 
        makesOrder = makesOrder.map(element => { return element.toLowerCase(); });

        const SortingPrioritize = (PrioList = []) =>
        {
            return ({make:a},{make:b}) => {
            let aPos = PrioList.indexOf(a.toLowerCase()), bPos = PrioList.indexOf(b.toLowerCase());
            return (aPos>-1 && bPos>-1) ? aPos - bPos 
                            : (aPos>-1) ? -1 
                            : (bPos>-1) ? +1 
                            : a-b
            } 
        }

        this.initialInventory.sort( SortingPrioritize(makesOrder) );

      } else if (payload.field === 'price') {
        const asc = payload.order === 'asc';

        const toNumber = (val) => {
          if (val == null) return 0;
          const n = parseFloat(String(val).replace(/[^\d.-]/g, ''));
          return Number.isFinite(n) ? n : 0;
        };

        this.initialInventory.sort((a, b) => {
          const pa = toNumber(a[payload.field]);
          const pb = toNumber(b[payload.field]);

          const aIsZero = pa <= 0;
          const bIsZero = pb <= 0;

          if (aIsZero !== bIsZero) return aIsZero ? 1 : -1;

          if (asc) return pa - pb;
          return pb - pa;
        });

      } else {
        this.initialInventory.sort((a, b) => {
          const va = a[payload.field];
          const vb = b[payload.field];

          const na = typeof va === 'number' ? va : Number(va);
          const nb = typeof vb === 'number' ? vb : Number(vb);

          let cmp;
          if (Number.isFinite(na) && Number.isFinite(nb)) {
            cmp = na - nb;
          } else {
            cmp = String(va).localeCompare(String(vb));
          }

          if (cmp < 0) return payload.order === 'asc' ? -1 : 1;
          if (cmp > 0) return payload.order === 'asc' ? 1 : -1;
          return 0;
        });
      }
    },
    arrayUnique(array) {
      var a = array.concat();
      for(var i=0; i<a.length; ++i) {
          for(var j=i+1; j<a.length; ++j) {
              if(a[i] === a[j])
                  a.splice(j--, 1);
          }
      }
  
      return a;
    },
    goToCompare(id, lang) {
      let compare;
      if (!localStorage.compare) {
        var Obj = {
          ids: [id],
        };
        localStorage.setItem('compare', JSON.stringify(Obj));
      } else {
        compare = JSON.parse(localStorage.compare);

        if (compare.ids.indexOf(id) == -1) compare.ids.push(id);

        if (compare.ids.length > 4) {
          compare.ids.splice(0, 1);
        }
        localStorage.compare = JSON.stringify(compare);
      }

      compare = JSON.parse(localStorage.compare);

      let urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4) break;

        urlIds.push(compare.ids[i]);
        j++;
      }

      var slug = '/compare/';
      if (lang == 'fr-CA')
        slug = '/comparer/'
      window.location.href = slug + '?vehicles=' + urlIds.join('|');
    },
    goToComparePage(id, lang){
      let urlIds = [];
      var j = 0;
      for (var i = compare.ids.length - 1; i >= 0; i--) {
        if (j >= 4) break;

        urlIds.push(compare.ids[i]);
        j++;
      }
      
      var slug = '/compare/';
      if (lang == 'fr-CA')
        slug = '/comparer/'
      window.location.href = slug + '?vehicles=' + urlIds.join('|');
    },
    filterInventory(payload) {
      this.inventory = EventBus.postFilterInventory(this.initialInventory, payload);
      this.goToPage(payload.page);
    },
    string_contains_value(text, filter) {
      var array = filter.toLowerCase().split("_");
      var total_words = array.length;
      var vehicle = text.split(' ').map((item) => {
        return item.toLowerCase();
      })
      var total_coincidences = 0;
      array.forEach((item) => {
        var total_i = vehicle.filter((span) => {
          return span.includes(item);
        }).length;

        var total_p = vehicle.filter((span) => {
          return span.replace(/-/g, '').includes(item.replace(/-/, ''));
        }).length;

        if (total_i > 0 || total_p > 0)
          total_coincidences++;
      })

      if (total_words == total_coincidences) {
        return true;
      }
      else {
        return false;
      }
    },
    isEmpty(val) {
      return (val === undefined || val == null || val.length <= 0) ? true : false;
    },
    goToPage(page) {
      this.currentPage = page;

      if(this.currentPage * this.ipp < this.inventory.length)
        this.displayMoreBtn = true;
      else
        this.displayMoreBtn = false;

      this.$nextTick(()=>{
        var lazyImages = [].slice.call(document.querySelectorAll(".vehicle-card .main-img"));
        if (!('IntersectionObserver' in window) ||
            !('IntersectionObserverEntry' in window) ||
            !('intersectionRatio' in window.IntersectionObserverEntry.prototype)) {
                lazyImages.forEach(img => {
                    img.src = img.dataset.src;
                });
        }else{
            let lazyImageObserver = new IntersectionObserver(function(entries, observer) {
                entries.forEach(function(entry) {
                    if (entry.isIntersecting) {
                        let lazyImage = entry.target;
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImageObserver.unobserve(lazyImage);
                    }
                });
            });
        
            lazyImages.forEach(function(lazyImage) {
              lazyImageObserver.observe(lazyImage);
            });
        }
      })
    },
  },
  computed: {
    inventoryPage() {
        //Obtaining model selected from NewAdvancedSearch or Gutenberg Options, for SRP Insert Image
        if(this.imagesForModels){
            let actualUrl = window.location.pathname.split("/");
            if(actualUrl.indexOf("model") >= 0){
                var modelS = actualUrl[actualUrl.indexOf("model")+1];
                var modelSelectedSplit = modelS.split(",");
                    if(this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ] !== undefined)
                        this.modelSelected = this.imagesForModels[ modelSelectedSplit[modelSelectedSplit.length-1] ];
                    else
                        this.modelSelected = null;
            }
            else if (this.gutembergOptions["model"] !== "all") {
              var model_name = this.gutembergOptions["model"]
              model_name = model_name.replace(/\s+/g, '-').toLowerCase();
              this.modelSelected = this.imagesForModels[this.gutembergOptions["model"].toLowerCase()] || this.imagesForModels[model_name] ;
            }
            else
                this.modelSelected = null;
        }else
            this.modelSelected = null;
    
      var base = this.currentPage - 1;
      if (!this.lMore && !this.lMoreBtn){
        return this.inventory.slice(base * this.ipp, (this.currentPage * this.ipp));
      }
      else {
        return this.inventory.slice(0, (this.currentPage * this.ipp));
      }

    },
    computedParams() {
      var globalRange = [0, 9999999999999];
      var mileageRange = (this.urlParams.mileage) ?
        [this.urlParams.mileage.since, this.urlParams.mileage.to] :
        globalRange;
      var priceRange = (this.urlParams.price) ?
        [this.urlParams.price.since, this.urlParams.price.to] :
        globalRange;
      var dryweightRange = (this.urlParams.dryweight) ? 
        [this.urlParams.dryweight.since, this.urlParams.dryweight.to] : 
      globalRange;
      var grossweightRange = (this.urlParams.grossweight) ? 
        [this.urlParams.grossweight.since, this.urlParams.grossweight.to] : 
      globalRange;
      var carprooflinkRange = (this.urlParams.carprooflink) ? 
        [this.urlParams.carprooflink.since, this.urlParams.carprooflink.to] : 
      globalRange;
      var paymentRange = (this.urlParams.payment) ?
        [this.urlParams.payment.since, this.urlParams.payment.to] :
      globalRange;
      var sleepcapacityRange = (this.urlParams.sleepcapacity) ? 
        [this.urlParams.sleepcapacity.since, this.urlParams.sleepcapacity.to] : 
      globalRange;

      var payload = {
        page: this.currentPageProp,
        stockNumber: this.urlParams.stocknumber || "",
        dryweightRange,
        grossweightRange,
        sleepcapacityRange,
        mileageRange,
        priceRange,
        carprooflinkRange,
        paymentRange,
        minPrice: globalRange[0],
        maxPrice: globalRange[1],
        minMileage: globalRange[0],
        maxMileage: globalRange[1],
        minDryweight: globalRange[0],
        maxDryweight: globalRange[1],
        minGrossweight: globalRange[0],
        maxGrossweight: globalRange[1],
        minSleepcapacity: globalRange[0],
        maxSleepcapacity: globalRange[1],
        minCarprooflink: globalRange[0],
        maxCarprooflink: globalRange[1],
        minPayment: globalRange[0],
        maxPayment: globalRange[1],
        filterValue: this.urlParams.filter || "",
        paymentFrequency: this.paymentFrequency || "",
        selected: {
          condition: this.urlParams.conditions || [],
          year: this.urlParams.years || [],
          make: this.urlParams.makes || [],
          lot: this.urlParams.lots || [],
          model: this.urlParams.models || [],
          type: this.urlParams.types || [],
          subtype: this.urlParams.subtypes || [],
          productline: this.urlParams.productlines || [],
          outsidelength: this.urlParams.outsidelengths || [],
          floorplan: this.urlParams.floorplans || [],
          trim: this.urlParams.trims || [],
          colour: this.urlParams.color || [],
          bodystyle: this.urlParams.bodystyles || [],
          transmission: this.urlParams.transmissions || [],
          drivetrain: this.urlParams.drivetrains || [],
          boxsize: this.urlParams.boxsizes || [],
          status: this.urlParams.status || [],
          salepending: this.urlParams.salependings || [],
          demo: this.urlParams.demos || [],
          asis: this.urlParams.asiss || [],
          certified: this.urlParams.certifieds || [],
          special: this.urlParams.specials || [],
          stock: this.urlParams.stocks || [],
          enginedisplacement: this.urlParams.enginedisplacements || [],
          package: this.urlParams.package || [],
          engine: this.urlParams.engines || [],
          location: this.urlParams.location || [],
          feature: this.urlParams.searchables || [],
          fueltype: this.urlParams.fueltypes || [],
          seat: this.urlParams.seats || [],
        },
      }

      return payload;
    },
    inventoryZero(){
      return this.inventory.length <= 0;
    }
  }
}